import type { WaitTipIconName } from '@steado/admin-contract/wait-tips';
import {
  ArrowLeftRight,
  Calendar,
  Camera,
  Cloud,
  Droplet,
  Dumbbell,
  MessageCircle,
  TrendingUp,
  UtensilsCrossed,
  type LucideIcon,
} from 'lucide-react';

/**
 * The console's stand-in for the app's own icon set.
 *
 * Not the same glyphs the Flutter client draws — it has its own set, and these
 * keys are its names — but close enough that an operator picking one is
 * picking the thing they think they are.
 *
 * Exhaustive over the contract's list, so there is no unknown-key case to fall
 * back from: adding a key without choosing a glyph is a compile error. The
 * app's own sparkle fallback is for a key written by a *newer* console than
 * the build the user is running, which this side cannot be.
 */
const GLYPHS: Readonly<Record<WaitTipIconName, LucideIcon>> = {
  utensils: UtensilsCrossed,
  camera: Camera,
  dumbbell: Dumbbell,
  messageCircle: MessageCircle,
  cloud: Cloud,
  droplet: Droplet,
  calendar: Calendar,
  trendingUp: TrendingUp,
  swap: ArrowLeftRight,
};

export interface WaitTipIconProps {
  readonly iconKey: WaitTipIconName;
  readonly className?: string;
}

export function WaitTipIcon({ iconKey, className }: WaitTipIconProps) {
  const Glyph = GLYPHS[iconKey];
  return <Glyph className={className} aria-hidden />;
}
